// React-Screen CUserFunctions - Strangler Phase 5 (entschalt).
// Runbook: tools/REACT-STRANGLER.md.
// ENTSCHALT am 23.8.2026 (Nutzer-Vorgabe: keine Huellen mehr, verbindlich
// sind Pixelgleichheit und 100% Funktionalitaet). React rendert die
// Knoepfe jetzt selbst ueber den gemeinsamen Baustein SecondaryPanel;
// der Legacy-Widget-Baum aus LYT_secondaryPanel.xml kommt nicht mehr vor.
// Die HANDLER sind weiter ueber spec.legacyMethods WOERTLICH uebernommen
// (Bridge-Vertrag 8) - `this`/`me` ist die Bridge.
import { defineReactScreen } from '../bridge.js';
import { SecondaryPanel } from '../secondaryPanel.jsx';

const legacy = {};


legacy.setMain = function(main) {
    this.Main = main;
}

legacy.setCallback = function() {
    POS.events.setOnClickEventCallback(this, this.disappear, true);
}

legacy.disappear = function(me) {
    me.Main.lastSubmenuId = "UF";
    window.setTimeout(me.Main.restoreLastSubmenuId, 0, me.Main);
/*    me.properties.styles.visibility = "hidden";
    me.reStyle();*/
document.getElementById(me.id).style.visibility="hidden";

}

legacy.printShopsData = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);
    var mode = parameters[1];

    /*privMan.enablePrivilege (privList);*/

    var sql = "SELECT * FROM SHOPS";
    if (mode == "this")
        sql += " WHERE POS_ID = " + POS.POSId;
    sql += " ORDER BY Address1"

    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function(rows) {
        //if (!r.recordCount())
        if (rows.length < 1) {
            sql = "SELECT * FROM SHOPS WHERE POS_ID = 1";
            var r2 = POS.SQLiteCon.execute(sql);
            $.when(r2).then(function(rows2) {
                printShopsDataHelper(rows2);
                return;
            });
        } else {
            printShopsDataHelper(rows);
        }

    });
}

function printShopsDataHelper(rows) {
    var Printer = new CPrinter();

    var r = Printer.head();
    $.when(r).then(function() {
        for (var i = 0; i < rows.length; i++) {
            var shopName = rows[i].Name;
            var address1 = rows[i].Address1;
            var address2 = rows[i].Address2;
            var openings = rows[i].OpeningTime;
            var telephone = rows[i].Telephone;

            var address2P = address2.split(" / ");
            if (address2P.length > 1)
                address2P[0] += " /";

            var openingsP = openings.split("#");

            var shopData = new Array();
            shopData.name = shopName;
            shopData.address1 = address1;
            shopData.address2 = address2P[0];
            shopData.address3 = address2P.length > 1 ? address2P[1] : null;
            shopData.telephone = telephone;
            shopData.openings1 = openingsP[0];
            shopData.openings2 = openingsP.length > 1 ? openingsP[1] : null;
            shopData.openings3 = openingsP.length > 2 ? openingsP[2] : null;

            Printer.addLine("A", 1, false, 2);
            Printer.addElement(POS.lang.getText("LABELS", "SHOP_NAME") + ":", 0, 0, false, 0, 14);
            Printer.addElement(shopData.name, 16, 0, true, 16, 40);
            Printer.addLine("A", 1, false, 0);
            Printer.addElement(POS.lang.getText("LABELS", "ADDRESS") + ":", 0, 0, false, 0, 14);
            Printer.addElement(shopData.address1, 16, 0, false, 16, 40);
            Printer.addLine("A", 1, false, 0);
            Printer.addElement(shopData.address2, 16, 0, false, 16, 40);
            Printer.addLine("A", 1, false, 2);
            if (shopData.address3) {
                Printer.addElement(shopData.address3, 16, 0, false, 16, 40);
                Printer.addLine("A", 1, false, 2);
            }
            Printer.addElement(POS.lang.getText("LABELS", "TELEPHONE_NUMBER") + ":", 0, 0, false, 0, 14);
            Printer.addElement(shopData.telephone, 16, 0, false, 16, 40);
            Printer.addLine("A", 1, false, 0);
            Printer.addElement(POS.lang.getText("LABELS", "OPENING_HOURS") + ":", 0, 0, false, 0, 14);
            Printer.addElement(shopData.openings1, 16, 0, false, 16, 40);
            Printer.addLine("A", 1, false, 0);
            if (shopData.openings2) {
                Printer.addElement(shopData.openings2, 16, 0, false, 16, 40);
                Printer.addLine("A", 1, false, 0);
            }
            if (shopData.openings3) {
                Printer.addElement(shopData.openings3, 16, 0, false, 16, 40);
                Printer.addLine("A", 1, false, 0);
            }
            Printer.addLine("A", 1, false, 5);

            //r.moveNext();
        }

        // r.free();

        var r2 = Printer.foot();
        $.when(r2).then(function() {
            Printer.print();
        });
    });

}


legacy.report = function(component, parameters) {

    return;

}


legacy.printLuckyNumber = function() {
    var Printer = new CPrinter();

    var r2 = Printer.head();
    $.when(r2).then(function() {
        var customerData = new Array();
        customerData.firstName = "__________________________";
        customerData.surname = "";
        customerData.address = "__________________________";
        customerData.zip = "_____";
        customerData.city = "____________________";
        customerData.telephone = "__________________________";
        customerData.email = "__________________________";

        Printer.addLine("A", 2, false, 0);
        Printer.addElement(POS.lang.getText("LABELS", "CUSTOMER_DATA_33GAME"), 20, 2, true, 0, 41);
        Printer.addLine("B", 1, false, 1);

        Printer.addLine("A", 1, false, 0);
        Printer.addElement(POS.lang.getText("LABELS", "CUSTOMER_DATA") + ":", 20, 2, true, 0, 41);
        Printer.addLine("B", 1, false, 3);

        Printer.addLine("A", 1, false, 3);
        Printer.addElement(POS.lang.getText("LABELS", "NAME") + ":", 0, 0, false, 0, 10);
        Printer.addElement(customerData.firstName + " " + customerData.surname, 11, 0, false, 11, 40);
        Printer.addLine("A", 1, false, 3);
        Printer.addElement(POS.lang.getText("LABELS", "ADDRESS") + ":", 0, 0, false, 0, 10);
        Printer.addElement(customerData.address, 11, 0, false, 11, 40);
        Printer.addLine("A", 1, false, 3);
        Printer.addElement(customerData.zip + " " + customerData.city, 11, 0, false, 11, 40);
        Printer.addLine("A", 1, false, 3);
        Printer.addElement(POS.lang.getText("LABELS", "TELEPHONE_NUMBER") + ":", 0, 0, false, 0, 10);
        Printer.addElement(customerData.telephone, 11, 0, false, 11, 40);
        Printer.addLine("A", 1, false, 3);
        Printer.addElement(POS.lang.getText("LABELS", "EMAIL") + ":", 0, 0, false, 0, 10);
        Printer.addElement(customerData.email, 11, 0, false, 11, 40);

        Printer.addLine("B", 1, false, 2);
        Printer.addLine("A", 1, false, 0);
        Printer.addElement(POS.lang.getText("LABELS", "SIGNATURE") + ":", 0, 0, false, 0, 41);
        Printer.addLine("B", 1, false, 6);
        Printer.addLine("B", 1, false, 6);
        Printer.addDivisionLine();

        Printer.addLine("A", 1, false, 1);
        Printer.addElement(POS.lang.getText("LABELS", "DATA_ONLY_FOR_FILE"), 20, 2, true, 0, 41);
        Printer.addLine("B", 1, false, 1);

        Printer.addBarcodeLine("AA", 2, 72, "6660330330330", 1);

        Printer.addLine("A", 1, false, 1);
        Printer.addElement(POS.lang.getText("LABELS", "LUCKY_DAY_HOWTO_1"), 20, 2, true, 0, 41);
        Printer.addLine("A", 1, false, 1);
        Printer.addElement(POS.lang.getText("LABELS", "LUCKY_DAY_HOWTO_2"), 20, 2, true, 0, 41);
        Printer.addLine("B", 1, false, 1);

        // registers it in the database
        /*privMan.enablePrivilege (privList);*/

        var d = new Date();
        var timestamp = (d / 1000).toFixed(0);
        var userId = POS.sessions.currentSession;

        var sql = "SELECT Name, Login FROM U Where U_ID = " + userId;
        var r = POS.SQLiteCon.execute(sql);
        $.when(r).then(function(rows) {
            var userName = rows[0].Name;
            var userLogin = rows[0].Login;
            //r.free();

            sql = "INSERT INTO BON " +
                "(Closed, Start, End, POS_ID, U_ID, UName, Cancelled, Type, CUST_ID, Exported) " +
                "VALUES (0, " + timestamp + ", 0, " + POS.POSId +
                ", " + userLogin + ", '" + userName + "', 0, '33R', NULL, 0)";

            if (!now)
                window.now = new Date();

            var text = expandInteger(now.getDate(), 2) +
                "." + expandInteger(now.getMonth() + 1, 2) +
                "." + now.getFullYear() + ", " + expandInteger(now.getHours(), 2) +
                ":" + expandInteger(now.getMinutes(), 2);

            Printer.addLine("A", 1, false, 1);
            Printer.addElement(POS.lang.getText("LABELS", "DATE") + ", " +
                POS.lang.getText("LABELS", "TIME") +
                ": " + text, 0, 0, false, 0, 55);
            Printer.addLine("A", 1, false, 1);
            Printer.addElement(POS.lang.getText("LABELS", "USER") + ": " + userName);
            Printer.addLine("B", 1, false, 1);

            var r3 = Printer.foot();
            $.when(r3).then(function() {
                Printer.print();

                POS.SQLiteCon.execute(sql);
            });
        });
    });
}

legacy.userChange = function() {
    POS.sessions.hideCurrentSession();

    POS.sessions.openSessions[0].initDisplay();

    POS.sessions.openSessions[0].components.container.
    components.user.field.input.setFocus();
}


function CUserFunctionsScreen({ bridge }) {
  const t = bridge.t;

  const knoepfe = [
    // btns[0] haengt im Legacy direkt an POS.sessions.goPause, nicht an einer
    // Screen-Methode - das bleibt so.
    { text: t('BUTTONS', 'GO_PAUSE'), handler: POS.sessions.goPause },
    { text: t('BUTTONS', 'CHANGE_USER'), handler: bridge.userChange },
    { text: t('BUTTONS', 'PRINT_LUCKY_NUMBER'), handler: bridge.printLuckyNumber },
    { text: t('BUTTONS', 'SHOP_DATA'), handler: bridge.printShopsData, param1: 'this' },
    { text: t('BUTTONS', 'ALL_SHOPS_DATA'), handler: bridge.printShopsData, param1: 'all' },
    { text: 'Umsatzbericht', handler: bridge.report, param1: 'all' },
    { text: 'Umsatzbericht RVL', handler: bridge.report, param1: 'rvl' },
  ];

  return <SecondaryPanel bridge={bridge} spalten={7} knoepfe={knoepfe} />;
}

// Legacy-Konstruktor zum Uebertragen (addclass/htmlType/rootStyles/Felder):
// function CUserFunctions(id) {
//     this.construct(id,"secondaryPanel CUserFunctions");
// 
//     this.htmlType = "span";
// 
//     this.properties = {
//         styles: {}
//     }
// 
//     this.Main = null;
// }
export const CUserFunctions = defineReactScreen({
  className: 'CUserFunctions',
  addclass: 'secondaryPanel CUserFunctions',
  htmlType: 'span',
  Screen: CUserFunctionsScreen,
  // Kein prepare/mountLegacy mehr: das Legacy-prepare baute den
  // Widget-Baum aus LYT_secondaryPanel.xml, den rendert jetzt React
  // selbst (SecondaryPanel). Uebrig bleiben die Methoden - die sind
  // WOERTLICH die alten.
  legacyMethods: legacy,
});

// Der Legacy-Huelle lag neben der Klasse noch dieser Helfer bei; er
// wandert mit, damit legacy-bridge.js ihn weiter beziehen kann.
export { printShopsDataHelper };
